export default {
  email: 'Email',
  password: 'Password',
  password_confirmation: 'Password confirmation',
  phone_nums: 'Phone number',
  phone_number: 'Phone number',
  first_name: 'First name',
  last_name: 'Last name',
  user_id: 'User id',
  csv_file: 'CSV file',
  gift_code_file: 'Gift code file',
  limit_usage_amount: 'Limit usage amount',
  expiry_at: 'Expiry at',
  effective_at: 'Effective at',
  charge_amount: 'Charge amount',
  card_types: 'Card type',
  notification_content: 'Content',
  notification_title: 'Title',
  push_at: 'Scheduled at',
  against_policy: 'Against policy',
  crime_history: 'Crime history',
  address_check: 'Address check',
  comment: 'Comment',
  kyc_status: 'KYC status',
  started_at: 'Started at',
  end_at: 'End at',
  tranMonth: 'Transaction Date',
  type: 'type',
  version: 'version',
  link_store: 'link store',
  title: 'title',
  content: 'content',
};
